// extracted by mini-css-extract-plugin
export var root = "VvY2";
export var rootLink = "dp6H";